<template>
	<Layout class="p-5 bg-white">
		<Row class="m-1 float">
			<Col class="p-1" span="5">
			<Input v-model="deviceSearchKey.name" :placeholder="deviceName">
			<template #prepend>
				<span>设备名称</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceSearchKey.alarmValue">
			<template #prepend>
				<span>报警值</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceSearchKey.timeInterval" disabled>
			<template #prepend>
				<span>上传时间间隔</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.resSize">
			<template #prepend>
				<span>查看数据条数</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="4">
			<Button class="m-1 float-right" @click="cancel">返回</Button>
			<Button class="m-1 float-right" type="primary" shape="circle" @click="submit">提交</Button>
			</Col>
		</Row>

		<Row class="m-1 float">
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.concentration" clearable>
			<template #prepend>
				<span>最小浓度</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.concentrationMax" clearable>
			<template #prepend>
				<span>最大浓度</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.temperature" clearable>
			<template #prepend>
				<span>最低温度</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.temperatureMax" clearable>
			<template #prepend>
				<span>最高温度</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="4">
			<Button class="m-1 float-right" type="primary" @click="searchAct">更新</Button>
			<!-- <Button class="m-1 float-right" type="primary" @click="toAudio">回放</Button> -->
			</Col>
		</Row>

		<Row class="m-1 float">
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.pressure" clearable>
			<template #prepend>
				<span>最小气压</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Input v-model="deviceActSearchKey.pressureMax" clearable>
			<template #prepend>
				<span>最大气压</span>
			</template>
			</Input>
			</Col>
			<Col class="p-1" span="5">
			<Date-picker format="yyyy-MM-dd HH:mm:ss" type="datetime" @on-change="startDateChange" placeholder="选择开始时间">
			</Date-picker>
			</Col>
			<Col class="p-1" span="5">
			<Date-picker format="yyyy-MM-dd HH:mm:ss" type="datetime" @on-change="endDateChange" placeholder="选择结束时间">
			</Date-picker>
			</Col>

			<Col class="p-1" span="4">
			<Button class="m-1 float-right" v-show="!timer" type="primary" @click="auto">自动更新</Button>
			<Button class="m-1 float-right" v-show="timer" type="error" @click="auto">停止</Button>
			</Col>
		</Row>


		<Row class="m-1 float">
			<Col class="p-1" span="10">
			<Select v-model="deviceUnactiveAddKey.controlData" placeholder="指令" class="m-1">
				<Option v-for="item in contorl" :value="item.controlDataNum">
					{{ item.controlData }}
				</Option>
			</Select>
			</Col>

			<Col class="p-1" span="5">
			<Input v-model="deviceUnactiveAddKey.dataA" clearable>
			<template #prepend>
				<span>附属指令</span>
			</template>
			</Input>
			</Col>

			<Col class="p-1" span="4">
			<Button class="m-1 float-right" type="primary" @click="send">发送</Button>
			</Col>
		</Row>
		<Row class="m-1 float">
			<Col class="p-1" span="5">
			<Input v-model="statuDataSearchKey.statuData" disabled :placeholder="statuDataSearchKey.statuData">
			<template #prepend>
				<span>设备状态</span>
			</template>
			</Input>
			</Col>

			<Col class="p-1" span="19">
			<Select v-model="model" placeholder="浓度单位" @on-change="searchAct" class="m-1 float-right" size="small"
				style="width:100px">
				<Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			</Col>
		</Row>



		<template>
			<div class="echart" id="mychart" :style="myChartStyle"></div>
		</template>

		<img :src="imgPath" />

		<!-- 
		<div>
			<div id="container" style="width: 95%;height: 600px"></div>
		</div> -->
		<div>
			<div id="mapDiv" style="width: 95%; height: 600px"></div>
		</div>

	</Layout>

</template>
<script>
	export default {
		data() {
			return {
				deviceName: "",
				timer: "flase",
				loader: null,
				myChart: {},
				xData: [], //横坐标
				concentration: [], //浓度
				temperature: [], //温度
				pressure: [], //气压
				myChartStyle: {
					float: "left",
					width: "100%",
					height: "550px"
				}, //图表样式

				deviceSearchKey: {
					userId: "",
					id: "",
					deviceId: "",
					deviceNumber: "",
					deviceType: "",
					alarmValue: "",
					timeInterval: "",
					alarmValueMax: "",
					timeIntervalMax: "",
					name: ""
				},
				deviceActSearchKey: {
					deviceId: "",
					resSize: 50,
					concentration: "",
					concentrationMax: "",
					temperature: "",
					temperatureMax: "",
					pressure: "",
					pressureMax: "",
					startDate: "",
					endDate: "",
				},
				statuDataSearchKey: {
					statuDataId: "",
					statuData: "",
					statuDataNum: "",
					lie: "",
					deviceType: "",
				},
				deviceUnactiveAddKey: {
					deviceUnactiveId: "",
					timeDate: "",
					deviceType: "",
					deviceNumber: "",
					controlData: "",
					statuData: "",
					concentration: "",
					temperature: "",
					pressure: "",
					timeInterval: "",
					alarmValue: "",
					dataA: "",
					dataB: "",
					dataC: "",
					dataD: "",
					dataE: "",
					dataF: "",
					userId: "",
					done: ""
				},
				controlSearchKey: {
					controlDataId: "",
					controlData: "",
					controlDataNum: "",
					lie: 0,
					deviceType: "",
				},
				res: [],
				cityList: [{
						value: 'VOL',
						label: 'VOL'
					},
					{
						value: 'LEL',
						label: 'LEL'
					},
					{
						value: 'PPM',
						label: 'PPM'
					}
				],
				model: "PPM",
				contorl: [],
				contorlModel: "",
				userId: 0,
				lnglats: [],
				markIf: "true",
				map: null,
				imgPath: "",
				map: null,
				markers: []
			}
		},
		methods: {
			initEcharts() {
				const option = {
					dataZoom: [{
						type: 'slider',
						show: false,
						realtime: true,
						filterMode: 'none',
					}, ],
					"dataZoom": [{
						"show": true,
						"height": 16,
						"xAxisIndex": [
							0
						],
						//bottom: '2%',
						"start": 0,
						"end": 100,
						handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
						handleSize: '110%',
						handleStyle: {
							color: "#00007f",

						},
						textStyle: {
							color: "#fff"
						},
						borderColor: "#90979c"
					}, {
						"type": "inside",
						"show": true,
						"height": 15,
						"start": 1,
						"end": 35
					}],

					grid: {
						bottom: '25%',
					},

					xAxis: {
						axisLabel: {
							//x轴文字的配置
							show: true,
							interval: 0, //使x轴文字显示全
							rotate: 45
						},

						data: this.xData
					},
					legend: { // 图例
						data: ["浓度", "温度", "气压"],
						top: "0%"
					},
					yAxis: {},
					series: [{
						name: "浓度",
						data: this.concentration,
						type: "line", // 类型设置为折线图
						label: {
							show: true,
							position: "top",
							textStyle: {
								fontSize: 10
							}
						}
					}, {
						name: "温度",
						data: this.temperature,
						type: "line", // 类型设置为折线图
						label: {
							show: true,
							position: "top",
							textStyle: {
								fontSize: 10
							}
						}
					}, {
						name: "气压",
						data: this.pressure,
						type: "line", // 类型设置为折线图
						label: {
							show: true,
							position: "top",
							textStyle: {
								fontSize: 10
							}
						}
					}]
				};
				this.myChart = this.echarts.init(document.getElementById("mychart"));
				this.myChart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});

			},
			startDateChange: function(s) {
				this.deviceActSearchKey.startDate = s;
			},
			endDateChange: function(e) {
				this.deviceActSearchKey.endDate = e;
			},
			cancel: function() {
				clearTimeout(this.loader);
				this.myChart = {};
				this.$tabs.close();
			},
			submit: function() {
				var self = this;
				this.http.put({
					url: "/device/update",
					param: self.deviceSearchKey,
				}).then(() => {
					self.message.info("修改成功");
				});
			},
			init: function() {
				this.search()
				this.searchAct()
			},
			send: function() {
				let self = this;
				// if	(){

				// }
				this.http.post({
					url: "/device-unactive/new",
					param: self.deviceUnactiveAddKey
				}).then(data => {
					self.message.info("成功");
				});
			},
			search: function() {
				let self = this;
				this.http.get({
					url: "/device/page/g",
					param: self.deviceSearchKey
				}).then(data => {
					self.deviceSearchKey = data.DATA.records[0];
					self.$data.deviceName = self.$data.deviceSearchKey.deviceType + "型" + self.$data
						.deviceSearchKey.deviceNumber + "号设备";
					self.deviceUnactiveAddKey.deviceType = data.DATA.records[0].deviceType;
					self.deviceUnactiveAddKey.deviceNumber = data.DATA.records[0].deviceNumber;
					self.controlSearchKey.deviceType = data.DATA.records[0].deviceType;
					self.statuDataSearchKey.deviceType = data.DATA.records[0].deviceType;
				}).then(() => {
					this.controlSearchKey.lie = false;
					this.http.get({
						url: "/control-data/list",
						param: this.controlSearchKey
					}).then(data => {
						this.contorl = data
					})
				})
			},
			searchAct: function() {
				this.http.get({
					url: "/device-act/page/g",
					param: this.deviceActSearchKey
				}).then(data => {
					this.res = data.DATA;
					this.xData = [];
					this.concentration = [];
					this.temperature = [];
					this.pressure = [];
					// TODO 在这报错
					this.statuDataSearchKey.statuDataNum = data.DATA[data.DATA.length - 1].statuData;
					console.log(data.DATA);


					if (data.DATA[data.DATA.length - 1].dataC != null) {
						for (var i = data.DATA.length - 1; i >= 0; i--) {
							if (data.DATA[i].dataC != 0 && data.DATA[i].dataC != '0.jpg') {
								this.imgPath = "img/" + data.DATA[i].dataC
								i = -1;
							}
						}
					}
					this.lnglats = []

					data.DATA.forEach(item => {
						//if (item.dataA != null && item.dataA != 0 && item.dataB != null && item.dataB != 0) {}
						// this.gpsToGaoDe(item.dataA, item.dataB);
						this.processCoordinates(item.dataA, item.dataB);
					})

				}).then(() => {
					for (var i = 0; i < this.res.length; i++) {
						var num = this.res[i].concentration
						if (this.model == "VOL") {
							num = (this.res[i].concentration / 10000).toFixed(2);
						} else if (this.model == "LEL") {
							num = (this.res[i].concentration / 500).toFixed(2);
						}
						this.xData.push(this.res[i].timeDate);
						this.concentration.push(num);
						this.temperature.push(this.res[i].temperature);
						this.pressure.push(this.res[i].pressure);
					}
					this.initEcharts();
					// 添加天地图显示逻辑
					this.$nextTick(() => {
						if (!this.map) {
							this.initTianDiTuMap();
							console.log("再次初始化地图");
						}
						console.log("准备渲染地图");

						this.showDeviceLocations();
					});

				}).then(() => {
					this.statuDataSearchKey.lie = "";
					this.statuDataSearchKey.statuData = "";
					this.statuDataSearchKey.statuDataId = "";

					this.http.get({
						url: "/statu-data/list",
						param: this.statuDataSearchKey
					}).then(data => {
						this.statuDataSearchKey = data[0];
						console.log(data);

						// this.carGPSIP()
					})
				})
			},
			auto: function() {
				var self = this;
				if (this.timer == false) {
					self.loader = window.setInterval(() =>
						self.searchAct(), this.deviceSearchKey.timeInterval * 1000);
					this.timer = true;
				} else {
					clearTimeout(self.loader);
					this.timer = false;
				}
			},
			show: function(id, userId) {
				this.$router.push({
					name: "device_detail",
					params: {
						id,
						userId
					}
				});
			},
			toAudio() {
				this.$router.push({
					name: "device_audio",
					params: {

					}
				})
			},

			gpsToGaoDe: function(longitude, latitude) {
				// 注意传递的经纬度坐标要是数值型
				if (Number(this.$data.deviceSearchKey.deviceType) == 5) {
					const mark = this.util.GPS.gcj_encrypt(
						Number(latitude),
						Number(longitude)
					)
					this.lnglats.push([mark.lon, mark.lat])
				} else if (this.$data.deviceSearchKey.deviceType > 5) {
					const mark = this.util.GPS.gcj_encrypt(
						Number(latitude),
						Number(longitude)
					)
					this.lnglats.push([longitude, latitude])
				}

			},
			// 添加天地图初始化方法
			initTianDiTuMap() {
				// 创建地图对象
				this.map = new T.Map("mapDiv");
				// 设置地图中心点和缩放级别
				this.map.centerAndZoom(new T.LngLat(116.4074, 39.9042), 10);

				// 添加地图类型控件（自动加载图层）
				this.map.addControl(new T.Control.MapType());
				this.map.addControl(new T.Control.Zoom());

				// ✅ 显式添加图层（防止某些情况不加载）
				const vectorLayer = new T.TileLayer("c", {
					opacity: 1
				});
				this.map.addLayer(vectorLayer);

				// // 添加标记
				// const marker = new T.Marker(center);
				// this.map.addOverlay(marker);
			},

			// 显示设备位置点
			showDeviceLocations() {
				// 清除已有标记
				this.clearMarkers();

				// 遍历位置数据并添加标记
				for (let i = 0; i < this.lnglats.length; i++) {
					if (this.lnglats[i] && this.lnglats[i].length >= 2) {
						const lnglat = new T.LngLat(this.lnglats[i][0], this.lnglats[i][1]);

						// 创建标记
						const marker = new T.Marker(lnglat);
						this.map.addOverLay(marker);
						this.markers.push(marker);

						// 添加信息窗口
						const infoWin = new T.InfoWindow();
						// console.log("看看里面");
						// console.log(this.res);
						// console.log(i);
						// console.log(this.res[i]);
						// console.log(this.lnglats);
						// console.log("看了里面");
						// 修复信息窗口内容显示
						const content = `
						  <div>
						    <p>时间：${this.res[i].timeDate || ''}</p>
						    <p>浓度：${this.res[i].concentration || ''}</p>
						    <p>温度：${this.res[i].temperature || ''}</p>
						    <p>气压：${this.res[i].pressure || ''}</p>
						  </div>
						`;

						// const content = `
      //       <div>
      //         <p>时间：</p>0
      //         <p>浓度：</p>
      //         <p>温度：</p>
      //         <p>气压：</p>
      //       </div>
      //     `;
						// const content = `
						//       <div>
						//         <p>时间：${this.res[i].timeDate}</p>
						//         <p>浓度：${this.res[i].concentration}</p>
						//         <p>温度：${this.res[i].temperature}</p>
						//         <p>气压：${this.res[i].pressure}</p>
						//       </div>
						//     `;
						infoWin.setContent(content);
						marker.addEventListener("click", function() {
							infoWin.open(this.map, lnglat);
						});
					}
				}
			},

			// 清除地图标记
			clearMarkers() {
				if (this.markers.length > 0) {
					this.markers.forEach(marker => {
						this.map.removeOverLay(marker);
					});
					this.markers = [];
				}
			},

			// 修改 gpsToGaoDe 方法为适用于天地图的版本
			processCoordinates(longitude, latitude) {
				// 天地图可以直接使用原始GPS坐标或者转换后的坐标
				if (Number(this.$data.deviceSearchKey.deviceType) == 5) {
					// 如果需要转换坐标系
					const mark = this.util.GPS.gcj_encrypt(
						Number(latitude),
						Number(longitude)
					);
					this.lnglats.push([mark.lon, mark.lat]);

					// 创建地图实例
					// const point = new T.LngLat(mark.lon, mark.lat);
					// this.map.centerAndZoom(point, 12);
					// // 创建标记
					// const marker = new T.Marker(point);
					// // 将标记添加到地图
					// this.map.addOverLay(marker);
				} else if (this.$data.deviceSearchKey.deviceType > 5) {
					// 直接使用原始坐标
					this.lnglats.push([longitude, latitude]);
					// 创建地图实例
					// const point = new T.LngLat(longitude, latitude);
					// this.map.centerAndZoom(point, 12);
					// // 创建标记
					// const marker = new T.Marker(point);
					// // 将标记添加到地图
					// this.map.addOverLay(marker);
				}
			},


		},



		created: function() {},
		mounted: function() {
			this.$data.deviceSearchKey.id = this.$route.params.id;
			this.$data.deviceUnactiveAddKey.userId = this.$route.params.userId;
			this.$data.deviceActSearchKey.deviceId = this.$route.params.id;
			this.$data.deviceSearchKey.userId = this.$route.params.userId;
			this.init();
			this.timer = false;
			// 初始化天地图
			this.$nextTick(() => {
				this.initTianDiTuMap();
			});
		},
		beforeDestroy: function() {}
	}
</script>

<style>
</style>